import ProductBox from './ProductBox';

export default ProductBox;
